import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, TipoGasto, SaveTipoGastoDto, SearchTipoGastoRequest, ComunidadTiposGastos } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class TipoGastoService extends CrudService<TipoGasto, number, SaveTipoGastoDto, SearchTipoGastoRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'tipoGasto', sharedFunctions);

  }

  getComunidades(id: number): Observable<GenericResponse<ComunidadTiposGastos[]>> {
    return this._http.get<GenericResponse<ComunidadTiposGastos[]>>(this._serviceUrl + '/' + id + '/comunidades', this.httpOptions);
  }
}